const white = "#ffffff";
const grey = "#404040"; 
const darkBgColor = grey;
const invertedTextColor = white;
const textColor = grey;
const transparentBgColor = "rgba(255, 255, 255, .25)";
const shadow = "0 2px 4px 0 rgba(0, 0, 0, .5)";
const spaceBetweenItems = 12;
const fontFamilyBase = "'Source Sans Pro', sans-serif";

export const styles = (theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center"
  },
  noShadow: {
    WebkitBoxShadow: "none",
    MozBoxShadow: "none",
    boxShadow: "none",
    fontSize: 16,
  },
  topbarLink: {
    textDecoration: "none",
    color: "white",
    textAlign: "center",
    "&&:hover": {
      color: "white",
    },
  },
  productName: {
    position: "fixed",
    zIndex: 999,
    color: "white"
  },
  langGroup: {
    display: "flex",
    alignItems: "center",
  },
  langSelector: {
    width: "150px",
    backgroundColor: "#fff",
    marginLeft: 10,
  },
  topNavigation: {
    alignItems: "stretch",
    backgroundColor: white,
    boxShadow: shadow,
    boxSizing: "border-box",
    display: "flex",
    height: 54,
    justifyContent: "space-between",
    padding: "0 32px",
  },
  topNavigationDark: {
    backgroundColor: darkBgColor,
  },
  topNavigationTransparent: {
    backgroundColor: transparentBgColor,
  },
  topNavigationFixed: {
    left: 0,
    position: "fixed",
    right: 0,
    zIndex: 1,
  },
  navLeftItems: {
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-end",
    margin: `0 -${spaceBetweenItems}px`,
    padding: 0,
  },
  navRightItems: {
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-start",
    margin: `0 -${spaceBetweenItems}px`,
    padding: 0,
  },
  navItem: {
    margin: `0 ${spaceBetweenItems}px`,
  },
  navLogoWrapper: {
    alignItems: "center",
    background: "transparent",
    border: 0,
    cursor: "default",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    marginLeft: spaceBetweenItems,
    marginRight: spaceBetweenItems,
    padding: 0,
  },
  navTitle: {
    color: textColor,
    fontFamily: fontFamilyBase,
    fontSize: 24,
    fontWeight: 300,
    lineHeight: 1,
    margin: "0 0 0 9px",
    whiteSpace: "nowrap",
  },
  navTitleDark: {
    color: invertedTextColor,
  },
});
